import { decodeString } from "./user";

/** BC as full name or ISO2-style "BC" (Skyflow / forms vary). */
export const isBritishColumbiaProvince = (state = "") => {
	const s = decodeString(String(state).trim());
	return s === decodeString("british columbia") || s === "bc";
};

export const pickPatientProvince = (patient = {}) => String(patient?.state || patient?.province || "").trim();

/**
 * @param {boolean|undefined} isPatientLocationCentric - true: use patient; false: account holder; undefined: patient then account
 */
export const getEffectiveProvinceForBcScreening = ({ isPatientLocationCentric, accountHolderState, patientState }) => {
	const acct = String(accountHolderState || "").trim();
	const pat = String(patientState || "").trim();
	if (isPatientLocationCentric === true) return pat || acct;
	if (isPatientLocationCentric === false) return acct;
	return pat || acct;
};

/**
 * Whether the BC minor-ailment screening consents have to be collected.
 *
 * Lives here rather than in the start form because the steps that decide
 * whether to show that form at all have to know the same answer: its three
 * consents are required and are collected nowhere else in the intake, so a
 * step that skips the form when they apply drops them silently.
 *
 * The JustMeds iframe is the exception — there the pharmacist completes them
 * on the note through NoteMandatoryFields, not the patient.
 */
export const shouldShowBcMinorAilmentScreening = ({
	isJustmedsPatientIframe = false,
	isIntakeCountryCanada = false,
	isCurrentSegmentPharmacySegment = false,
	isPatientLocationCentric,
	accountHolderState,
	patientState,
} = {}) =>
	!isJustmedsPatientIframe &&
	Boolean(isIntakeCountryCanada) &&
	Boolean(isCurrentSegmentPharmacySegment) &&
	isBritishColumbiaProvince(
		getEffectiveProvinceForBcScreening({ isPatientLocationCentric, accountHolderState, patientState })
	);
